import React, { useState, useEffect } from 'react';

import cn from 'classnames';
import { debounce } from 'lodash';
import { number, string, func } from 'prop-types';

import Input from 'components/Common/Input';
import { debounceInterval } from 'constants/debounceInterval';

import s from './AlphaLastNameInput.css';

const AlphaLastNameInput = props => {
  const { maxValue, label, onChange, placeholder, initialValue } = props;
  const [value, setValue] = useState(initialValue);
  const isError = value?.length > maxValue;

  const debouncedOnChange = debounce(onChange, debounceInterval);

  useEffect(() => {
    if (initialValue && initialValue !== value) {
      setValue(initialValue);
    }
  }, [initialValue]);

  return (
    <div className={s.root}>
      <Input
        error={isError}
        onChange={e => {
          setValue(e.target.value);
          debouncedOnChange(e.target.value);
        }}
        fullWidth
        label={label}
        variant="outlined"
        className={s.input}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{
          className: s.inputClass,
        }}
        placeholder={placeholder}
        defaultValue={initialValue}
        value={value}
      />
      <div className={cn(s.countRow, { [s.error]: isError })}>
        {value?.length ?? 0}/{maxValue}
      </div>
    </div>
  );
};

AlphaLastNameInput.propTypes = {
  maxValue: number.isRequired,
  label: string.isRequired,
  onChange: func.isRequired,
  placeholder: string.isRequired,
  initialValue: string,
};

AlphaLastNameInput.defaultProps = {
  initialValue: '',
};

export default AlphaLastNameInput;
